<script type="text/javascript">
  export default {};
</script>

<template>
  <div class="overview-map-loader">
    <div class="overview-map-loader__avatar">
      <div class="overview-map-loader__avatar-circle"></div>
    </div>
    <div class="overview-map-loader__content">
      <div class="overview-map-loader__text-1"></div>
    </div>
  </div>
</template>

<style lang="scss">
  .overview-map-loader {
    @import '~styles/settings';

    display: flex;
    align-items: center;
    background: $white;
    height: 97px;
    padding: 0 20px;
    border-bottom: 1px solid $grey2;
    margin: 10px 0;
    justify-content: center;

    @include breakpoint($layout-breakpoint) {
      height: 234px;
      flex-flow: column;
    }

    &__avatar {
      width: 40%;

      @include breakpoint(medium down) {
        width: 100%;
      }

      &-circle {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background: $blue2;
        opacity: 0.4;

        @include breakpoint(medium down) {
          margin: 0 auto;
          width: 55px;
          height: 55px;
        }
      }
    }

    &__content {
      width: 75%;
      justify-content: space-between;
      display: none;

      @include breakpoint($layout-breakpoint) {
        display: flex;
        flex-flow: column;
        width: 100%;
        align-items: center;
      }
    }

    &__text-1 {
      @include text-line(50%, 20px);

      margin: 20px 0;
      border-radius: 20px;
    }

    &__text-2 {
      margin: 5px 0;

      @include text-line(20%, 20px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/content-loader/OverviewMapLoader.vue